'use strict';

angular.module('uniromaLandingApp')
.factory('PolicyAnag', ['$resource',function ($resource) {
	return {
		policies: $resource('api/anag-policies/:id', {}, {
			'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
		}),
		create: $resource('api/create-anag-policy', {}, {
			'nuova': { method: 'POST',
				params: {},
				isArray: true,
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			}
			
		})
	};
}]);


//(function() {
//    'use strict';
//    angular
//        .module('unimibLandingApp')
//        .factory('Policy', Policy);
//
//    Policy.$inject = ['$resource'];
//
//    function Policy ($resource) {
//        var resourceUrl =  'api/policies/:id';
//
//        return $resource(resourceUrl, {}, {
//            'query': { method: 'GET', isArray: true},
//            'get': {
//                method: 'GET',
//                transformResponse: function (data) {
//                    if (data) {
//                        data = angular.fromJson(data);
//                    }
//                    return data;
//                }
//            },
//            'update': { method:'PUT' },
//            'create':{
//            	method: 'POST',
//            	url: 'api/create-policy',
//            	params: {},
//				isArray: true,
//            }
//        });
//    }
//})();



